import { render, staticRenderFns } from "./emailAddPage.vue?vue&type=template&id=4782f066&scoped=true&"
import script from "./emailAddPage.vue?vue&type=script&lang=js&"
export * from "./emailAddPage.vue?vue&type=script&lang=js&"
import style0 from "./emailAddPage.vue?vue&type=style&index=0&id=4782f066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4782f066",
  null
  
)

export default component.exports